import './App.css';
import { Container, Row } from 'react-bootstrap';

import { useTopDataStore } from "./data/TopDataStoreProvider";
import { useStudyDataStore } from "./data/StudyDataStoreProvider";
import StudyText from "./asc.study.ID.edit";

// This sets the subpage within the Study module
function OutletSwitch() {
  // Temporary use of TopDataStoreProvider for page before adding router
  const { topData } = useTopDataStore();  
  switch (topData.page) {
    case "studyText":
    default:
      return (<StudyText />);
  }
}

export default function StudyOutletID() {
  const { studyData } = useStudyDataStore();

  // Page layout
  return(
    <Container className="mainPage">
      <Row>
        <h2 className="pageTitle">
          {(studyData.name)}
        </h2>
      </Row>
      <Row> 
        <OutletSwitch /> 
      </Row>
    </Container>
  );
}
